import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useAdminLogin = () => {

  const queryClient = useQueryClient();

  const login = async (loginData) => {
    const response = await client("auth/login", {
      method: "POST",
      data: loginData,
    });

    if (response.error) {
      throw new Error(response.error);
    }
    if (response?.token) {
      localStorage.setItem("token", response.token);
      localStorage.setItem("role", response.role);
      queryClient.invalidateQueries("token");
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };
  return useMutation(login);
};

export const useChangePassword = () => {
  const register = async (payload) => {
    const response = await client("auth/changePassword", {
      method: "POST",
      data: payload,
    });

    if (response.error) {
      throw new Error(response.error);
    }
    if (response) {
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useForgetPassword = () => {
  const register = async (payload) => {
    const response = await client("auth/forgotPassword", {
      method: "POST",
      data: payload,
    });

    if (response.error) {
      throw new Error(response.error);
    }
    if (response) {
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useCheckIn = () => {
  const queryClient = useQueryClient();
  const mutation = async () => {
    const response = await client("auth/checkIn", {
      method: "POST",
    });

    if (response.error) {
      throw new Error(response.error);
    }
    // if (response) {
    //   queryClient.invalidateQueries({ queryKey: ["getLogedInUser"] });
    //   return response;
    // } else {
    //   throw new Error("Unexpected response from the server");
    // }
  };

  return useMutation(mutation);
};

export const useCheckOut = () => {
  const queryClient = useQueryClient();
  const mutation = async () => {
    const response = await client("auth/checkOut", {
      method: "POST",
    });

    if (response.error) {
      throw new Error(response.error);
    }
    // if (response) {
    //   queryClient.invalidateQueries({ queryKey: ["getLogedInUser"] });
    //   return response;
    // } else {
    //   throw new Error("Unexpected response from the server");
    // }
  };

  return useMutation(mutation);
};

export const useVerifyToken = () => {
  return useMutation(async (payload) => {
    const response = await client("auth/verifyToken", {
      method: "POST",
      data: payload,
    });
    return response;
  });
};

export const useCreateAdmin = () => {
  const queryClient = useQueryClient();
  const register = async (registerData) => {
    const response = await client("auth/createAdmin", {
      method: "POST",
      data: registerData,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response?.user?.role) {
      queryClient?.invalidateQueries(["getAllAdmins"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();

  const register = async (id) => {
    const response = await client(`auth/deleteAdmin/${id}`, {
      method: "POST",
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response) {
      queryClient.invalidateQueries(["getAllAdmins"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useGetAllAdmins = ({ limit, offset }) => {
  return useQuery(["getAllAdmins", limit, offset], async () => {
    const response = await client(
      `auth/getAllAdmins?offset=${offset}&limit=${limit}`
    );
    return response;
  });
};

export const useCreateStudent = () => {
  const queryClient = useQueryClient();
  const register = async (registerData) => {
    const response = await client("auth/createStudent", {
      method: "POST",
      data: registerData,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response?.user?.role) {
      queryClient?.invalidateQueries(["getAllStudents"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useDeleteStudent = () => {
  const queryClient = useQueryClient();

  const register = async (id) => {
    const response = await client(`auth/deleteStudent/${id}`, {
      method: "POST",
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response) {
      queryClient.invalidateQueries(["getAllStudents"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useGetAllStudents = ({ limit, offset }) => {
  return useQuery(["getAllStudents", limit, offset], async () => {
    const response = await client(
      `auth/getAllStudents?offset=${offset}&limit=${limit}`
    );
    return response;
  });
};

export const useCreateTeacher = () => {
  const queryClient = useQueryClient();
  const register = async (registerData) => {
    const response = await client("auth/createTeacher", {
      method: "POST",
      data: registerData,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response?.user?.role) {
      queryClient?.invalidateQueries(["getAllTeachers"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};
export const useApproveStudent = () => {
  const queryClient = useQueryClient();
  const register = async (studentId) => {
    const response = await client("auth/approveStudent", {
      method: "POST",
      studentId: studentId,
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response) {
      queryClient?.invalidateQueries(["getAllStudents"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useDeleteTeacher = () => {
  const queryClient = useQueryClient();

  const register = async (id) => {
    const response = await client(`auth/deleteTeacher/${id}`, {
      method: "POST",
    });

    if (response.error) {
      throw new Error(response.error);
    }

    if (response) {
      queryClient.invalidateQueries(["getAllTeachers"]);
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useGetAllTeachers = ({ limit, offset }) => {
  return useQuery(["getAllTeachers", limit, offset], async () => {
    const response = await client(
      `auth/getAllTeachers?offset=${offset}&limit=${limit}`
    );
    return response;
  });
};

export const useGetAdminsByOrganization = ({ limit, offset }) => {
  const register = async (registerData) => {
    const response = await client(
      `auth/getAdminsByOrganization?offset=${offset}&limit=${limit}`,
      {
        method: "POST",
        data: registerData,
      }
    );

    if (response?.error) {
      throw new Error(response.error);
    }

    if (response) {
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useGetUsersByOrganization = ({ limit, offset }) => {
  const register = async (registerData) => {
    const response = await client(
      `auth/getUsersByOrganization?offset=${offset}&limit=${limit}`,
      {
        method: "POST",
        data: registerData,
      }
    );
    if (response?.error) {
      throw new Error(response.error);
    }
    if (response) {
      return response;
    } else {
      throw new Error("Unexpected response from the server");
    }
  };

  return useMutation(register);
};

export const useGetAttendances = (startDate, endDate) => {
  return useQuery(["getAttendances", startDate, endDate], async () => {
    let url = `auth/getCheckInTimes`;
    if (startDate) {
      url = url + `?startDate=${startDate}`;
    }
    if (endDate) {
      url = url + `&endDate=${endDate}`;
    }
    const response = await client(url);
    return response;
  });
};

// export const useGetAdminsByOrganization = () => {
//   return useQuery(["getAdminsByOrganization"], async () => {
//     const response = await client(
//       `auth/getAdminsByOrganization`
//     );
//     return response;
//   });
// };

export const useGetAllUsers = ({ limit, offset }) => {
  return useQuery(["getAllUsers", limit, offset], async () => {
    const response = await client(
      `auth/getAllUsers?offset=${offset}&limit=${limit}`
    );
    return response;
  });
};

// export const useGetLogedInUser = () => {
//   return useQuery(["getLogedInUser"], async () => {
//     const response = await client(`auth/getLogedInUser`);
//     return response;
//   });
// };
